module.exports = __webpack_public_path__ + "static/media/4_8.6d26ccd2.png";